import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgSmTwitterMonochrome = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.498 15.316 26.316 6h-1.853l-6.788 8.088L12.253 6H6l8.199 12.231L6 28h1.853l7.168-8.542L20.747 28H27l-8.502-12.684Zm-2.538 3.023-.83-1.218L8.52 7.43h2.846l5.334 7.82.83 1.219 6.934 10.166h-2.846L15.96 18.34Z",
  fill: "#000"
})));

export { SvgSmTwitterMonochrome as default };
